const IntercomScript = (APP_ID) => {
  const i = function() {
   i.c(arguments);
  };
  i.q = [];
  i.c = function(args) {
   i.q.push(args);
  };
  window.Intercom = i;

  const loadScript = () => {
    const s = document.createElement('script');
    s.async = true;
    s.src = 'https://widget.intercom.io/widget/' + APP_ID;
    document.head.appendChild(s);
  };

  if (document.readyState === 'complete') {
    loadScript();
  } else if (window.attachEvent) {
    window.attachEvent('onload', loadScript);
  } else {
    window.addEventListener('load', loadScript,false);
  }
};

export default IntercomScript;
